import { FeatureCategory } from '../types';

export const dashboardFeatures: FeatureCategory = {
  name: "Personal Dashboard & Planning",
  icon: "LayoutDashboard",
  features: [
    { 
      name: "Personal Dashboard", 
      description: "Centralized hub showing your ThriveScore, upcoming appointments, daily check-ins, and personalized insights in one convenient location.",
      starter: "✔", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Goals & Progress Tracking", 
      description: "Set personalized wellness goals for fitness, social engagement, brain health, and safety. Track progress with visual charts and celebrate achievements.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Google Calendar Integration", 
      description: "Sync with Google Calendar to view appointments, set medication reminders, and share schedules with family members.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Apple Calendar Integration", 
      description: "Sync with Apple Calendar to view appointments, set medication reminders, and share schedules with family members.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    },
    { 
      name: "Smart Speaker Integration (Alexa, Google Home)", 
      description: "Voice control integration with Alexa and Google Home for hands-free access to reminders, updates, and daily check-ins.",
      starter: "—", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "👁"
    }
  ]
};
